import React from 'react';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { GearFieldWrapper } from '../GearFieldWrapper';
import { DatePicker, DateTimePicker } from '@progress/kendo-react-dateinputs';

interface FormDatePickerProps extends FieldRenderProps {
  includeTime?: boolean;
}

export const FormDatePicker: React.FC<FormDatePickerProps> = fieldRenderProps => {
  const { includeTime, name, value, onChange, disabled } = fieldRenderProps;

  const dateValue =
    value !== undefined && value !== null && value !== '' ? (value instanceof Date ? value : new Date(value)) : null;

  const pickerKey = React.useMemo(
    () => (value === null || value === undefined || value === '' ? Date.now() : 'picker'),
    [value]
  );

  const popupSettings = {
    popupClass: 'form-date-picker-popup',
    collision: {
      horizontal: 'flip' as const,
      vertical: 'flip' as const
    },
    animate: true
  };

  const commonProps = {
    name,
    value: dateValue,
    onChange,
    disabled,
    popupSettings
  };

  return (
    <GearFieldWrapper {...fieldRenderProps}>
      {includeTime ? (
        <DateTimePicker key={pickerKey} {...commonProps} />
      ) : (
        <DatePicker key={pickerKey} {...commonProps} />
      )}
    </GearFieldWrapper>
  );
};
